<template>
<CRow>
    <CCol col="12" sm="9" md="7" class="mx-auto alert alert-warning">
        <p>کاربر محترم، در میزان مبلغ شارژ کیف پول دقت داشته باشید پس از شارژ کیف پول امکان عودت وجه وجود ندارد.</p>
    </CCol>

    <CCol col="12" sm="9" md="7" class="mx-auto">
        <CCard>
            <CCardBody>
                <ChargeForm :transaction="transaction" :submit="submit"  ref="chargeForm" />
            </CCardBody>
        </CCard>
    </CCol>
</CRow>
</template>

<script>
import { mapActions } from 'vuex'
import { ChargeForm } from './partials'

export default {
    name: 'ChargeAccount',

    data() {
        return {
            transaction: {
                amount: 10000000,
                coupon_code: null
            }
        }
    },

    components: {
        ChargeForm,
    },

    methods: {
        ...mapActions({
            charge: 'transaction/charge',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading'
        }),
        submit() {
            const chargeForm = this.$refs.chargeForm
            this.setShowLoading()
            this.resetMsg()

            const data = {
                amount: this.transaction.amount,
                callback_address: this.$url('transactions/charge/response'),
                coupon_code: this.transaction.coupon_code
            }

            this.charge(data)
                .then(result => this.$redirect(result.redirect_to))
                .catch(result => {
                    if(result.data) {
                        chargeForm.$refs.form.setErrors(result.data);
                    }
                    this.setShowLoading(false)
                    this.setMsg({
                        content: this.$t('tags.'+result.tag),
                        type: 'danger'
                    })
                })
        }
    }
}
</script>